import React from 'react';
import { View } from 'react-native';
import { scale } from '@components/frame';
import TouchableElement from '@components/common/touchableElement';
import Svg from '@styles/icons/svg';

export default ({ C, rotate = 0, onPress }) => {
  return (
    <TouchableElement onPress={onPress}>
      {({ boxStyle, pressHoverColor }) => (
        <View
          style={[
            boxStyle,
            {
              width: scale(32),
              height: scale(32),
              borderRadius: scale(32) / 2,
              backgroundColor: C(pressHoverColor('Button/Light/Secondary')),
              justifyContent: 'center',
              alignContent: 'center',
              alignItems: 'center',
            },
            rotate > 0 ? { marginLeft: scale(18) } : { marginRight: scale(18) },
          ]}
        >
          <View
            style={[
              {
                transform: [
                  {
                    rotate: `${rotate}deg`,
                  },
                ],
              },
              rotate > 0 ? { marginRight: scale(-2) } : { marginLeft: scale(-2) },
            ]}
          >
            <Svg icon="chevronLeft" width={scale(11)} height={scale(16)} color={'Button/Light/Primary'} />
          </View>
        </View>
      )}
    </TouchableElement>
  );
};
